module.exports = __webpack_public_path__ + "static/media/informationen_avacon.94a7b22b.svg";